import { useState } from "react";
import { set, useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

import { usePostApi } from "../../../../../hooks";
import { useSelector } from "../../../../../redux/hooks";
import { getYachtId } from "../../../../../utils";
import { Notification } from "../../../../../utils/Notification";
import { Button } from "../../../../shared/Button/Button";
import { parseSaveData } from "./utils";
interface Props {
  refetch: () => Promise<void>;
}
const SaveMedicalHistory = ({ refetch }: Props) => {
  const { getValues } = useFormContext();
  const { userid } = useParams();
  const [loading, setLoading] = useState(false);
  const medData = useSelector(state => state.medicalHistory);

  const { post } = usePostApi();
  const handleSave = async () => {
    setLoading(true);
    const parsedData = parseSaveData(getValues(), medData);
    if (!userid) return;
    await post({
      request: "save-med-info",
      body: {
        params: {
          userid,
          yachtid: getYachtId(),
          ...parsedData,
        },
      },
      onSuccess: () => {
        Notification("Success", "Medical history saved successfully", "green");
      },
    });
    await refetch();
    setLoading(false);
  };
  return (
    <Button onClick={handleSave} loading={loading} style={{ borderWidth: 2 }}>
      <span style={{ fontWeight: 200 }}>Save</span>
    </Button>
  );
};
export default SaveMedicalHistory;
